class {
  onCreate() {
    this.state = {};
  }
}

<component-def/>
$ input.renderBody(out, componentDef, component, state);
